<template>
  <div>
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li><router-link to="/clients">Applications</router-link></li>
        <li><router-link v-bind:to="`/clients/${this.$route.params.client_id}`">{{ this.$store.state.client.name }}</router-link></li>
        <li class="is-active"><a href="#" aria-current="page">Articles</a></li>
      </ul>
    </nav>

    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <div class="field">
            <p><router-link v-bind:to="`/clients/${this.$route.params.client_id}/articles/create`" class="button is-info">Create new article</router-link></p>
          </div>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <p>Total: <strong>{{ this.$store.state.clientArticlesTotal | numberDisplay }}</strong> articles</p>
        </div>
      </div>
    </nav>

    <pagination
      v-bind:urlBuilder="buildPaginatorUrls"
      v-bind:currentPage="currentPage"
      v-bind:lastPage="lastPage"
      v-bind:displayPage="5"
      class="is-small" />

    <table class="table is-striped is-fullwidth">
      <thead>
        <tr>
          <th>ID</th>
          <th>Title</th>
          <th>Location</th>
          <th>Type</th>
          <th>Created at</th>
          <th>Updated at</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!this.$store.state.clientArticles.length">
          <td colspan="6" class="has-text-centered has-text-grey">No articles found</td>
        </tr>
        <tr v-for="item in this.$store.state.clientArticles">
          <td>{{ item.id }}</td>
          <td><router-link v-bind:to="`/clients/${item.client_id}/articles/${item.id}`">{{ item.title }}</router-link></td>
          <td>{{ item.location }}</td>
          <td>
            <span v-if="item.content" class="icon is-small tooltip" data-tooltip="Text content"><i class="fa fa-file-text-o"></i></span>
            <span v-else class="icon is-small tooltip" data-tooltip="Link"><i class="fa fa-link"></i></span>
          </td>
          <td>{{ item.created_at }}</td>
          <td>{{ item.updated_at }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import Pagination from 'vue-bulma-pagination'

  export default {
    computed: {
      currentPage () {
        return parseInt(this.$route.query.page) || 1
      },

      lastPage () {
        return Math.ceil(this.$store.state.clientArticlesTotal / 20)
      }
    },

    methods: {
      buildPaginatorUrls (page) {
        return { query: { ...this.$route.query, page } }
      }
    },

    created () {
      this.$store.dispatch('getClient', {
        clientId: this.$route.params.client_id
      })

      this.$store.dispatch('getClientArticles', {
        clientId: this.$route.params.client_id,
        params: this.$route.query
      })
    },

    watch: {
      '$route.query' (query) {
        this.$store.dispatch('getClientArticles', {
          clientId: this.$route.params.client_id,
          params: this.$route.query
        })
      }
    },

    components: {
      Pagination
    }
  }
</script>



// WEBPACK FOOTER //
// ArticleList.vue?38761a94